import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  center: {
    textAlign: 'center',
    justifyContent: 'center',
  },
  preview: {
    background: '#fff',
    border: '1px solid #000',
  },
  width100: {
    width: '100%',
  },
  buttonArea: {
    marginLeft: '2rem',
  },
  button: {
    border: '1px solid',
    width: '45%',
    height: '3rem',
  },
  messageBox: {
    marginLeft: '2rem',
    '& p': {
      fontSize: '0.8rem',
    },
  },
  dropArea: {
    padding: '1rem 2rem 0',
  },
  dropToolArea: {
    margin: '0 2rem 2rem',
    height: '48px',
    border: '1px solid',
    borderTop: 'none',
    width: '100%',
  },
  toolButton: {
    display: 'inline-block',
    margin: '6px',
    padding: '1px 8px',
    border: '1px solid',
  },
  buttonContainer: {
    padding: theme.spacing(0.5, 1.5),
    display: 'inline-flex',
  },
}))

export default useStyles
